var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "35px",
    viewBox: "0 0 47 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "image-regular") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.671564 0 0 0 0 0.671564 0 0 0 0 0.671564 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    transform: "translate(-547.000000, -338.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "image-regular"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(547.000000, 338.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.59375,0 L4.40625,0 C1.97271484,0 0,1.95872396 0,4.375 L0,30.625 C0,33.041276 1.97271484,35 4.40625,35 L42.59375,35 C45.0272852,35 47,33.041276 47,30.625 L47,4.375 C47,1.95872396 45.0272852,0 42.59375,0 Z M42.0429688,30.625 L4.95703125,30.625 C4.65284317,30.625 4.40625,30.3801557 4.40625,30.078125 L4.40625,4.921875 C4.40625,4.61984428 4.65284317,4.375 4.95703125,4.375 L42.0429688,4.375 C42.3471568,4.375 42.59375,4.61984428 42.59375,4.921875 L42.59375,30.078125 C42.59375,30.3801557 42.3471568,30.625 42.0429688,30.625 L42.0429688,30.625 Z M11.75,8.02083333 C9.72211523,8.02083333 8.078125,9.65316406 8.078125,11.6666667 C8.078125,13.6801693 9.72211523,15.3125 11.75,15.3125 C13.7778848,15.3125 15.421875,13.6801693 15.421875,11.6666667 C15.421875,9.65316406 13.7778848,8.02083333 11.75,8.02083333 Z M8.8125,26.25 L38.1875,26.25 L38.1875,18.9583333 L30.1538965,10.9817057 C29.7237363,10.5545964 29.0262637,10.5545964 28.5960117,10.9817057 L17.625,21.875 L13.9976465,18.2733724 C13.5674863,17.846263 12.8700137,17.846263 12.4397617,18.2733724 L8.8125,21.875 L8.8125,26.25 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.9b1e2d0d558ba82dc4e4f6c2d2be1a4c.svg";
export { ForwardRef as ReactComponent };